import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <mask id="ursa-icon__InfoIcon__20__ida" fill="#fff">
            <path
                fillRule="evenodd"
                d="M10 9.3a.7.7 0 0 1 .7.7v2.96a.7.7 0 0 1-1.4 0V10a.7.7 0 0 1 .7-.7"
                clipRule="evenodd"
            />
            <path
                fillRule="evenodd"
                d="M10 4.4a5.6 5.6 0 1 0 0 11.2 5.6 5.6 0 0 0 0-11.2M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
                clipRule="evenodd"
            />
            <path d="M9.25 7.732a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0" />
        </mask>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10 9.3a.7.7 0 0 1 .7.7v2.96a.7.7 0 0 1-1.4 0V10a.7.7 0 0 1 .7-.7"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10 4.4a5.6 5.6 0 1 0 0 11.2 5.6 5.6 0 0 0 0-11.2M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M9.25 7.732a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0" />
        <path
            fill="currentColor"
            d="M9.25 7.732h-1.5zm.75-.75v1.5zm.75.75h-1.5zm-.75.75v1.5zM12.2 10A2.2 2.2 0 0 0 10 7.8v3a.8.8 0 0 1-.8-.8zm0 2.96V10h-3v2.96zm-2.2 2.2a2.2 2.2 0 0 0 2.2-2.2h-3a.8.8 0 0 1 .8-.8zm-2.2-2.2a2.2 2.2 0 0 0 2.2 2.2v-3a.8.8 0 0 1 .8.8zm0-2.96v2.96h3V10zM10 7.8A2.2 2.2 0 0 0 7.8 10h3a.8.8 0 0 1-.8.8zM5.9 10A4.1 4.1 0 0 1 10 5.9v-3A7.1 7.1 0 0 0 2.9 10zm4.1 4.1A4.1 4.1 0 0 1 5.9 10h-3a7.1 7.1 0 0 0 7.1 7.1zm4.1-4.1a4.1 4.1 0 0 1-4.1 4.1v3a7.1 7.1 0 0 0 7.1-7.1zM10 5.9a4.1 4.1 0 0 1 4.1 4.1h3A7.1 7.1 0 0 0 10 2.9zm0-4.4A8.5 8.5 0 0 0 1.5 10h3A5.5 5.5 0 0 1 10 4.5zm8.5 8.5A8.5 8.5 0 0 0 10 1.5v3a5.5 5.5 0 0 1 5.5 5.5zM10 18.5a8.5 8.5 0 0 0 8.5-8.5h-3a5.5 5.5 0 0 1-5.5 5.5zM1.5 10a8.5 8.5 0 0 0 8.5 8.5v-3A5.5 5.5 0 0 1 4.5 10zm9.25-2.268a.75.75 0 0 1-.75.75v-3a2.25 2.25 0 0 0-2.25 2.25zm-.75.75a.75.75 0 0 1-.75-.75h3A2.25 2.25 0 0 0 10 5.482zm-.75-.75a.75.75 0 0 1 .75-.75v3a2.25 2.25 0 0 0 2.25-2.25zm.75-.75a.75.75 0 0 1 .75.75h-3A2.25 2.25 0 0 0 10 9.982z"
            mask="url(#ursa-icon__InfoIcon__20__ida)"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
